import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input } from '@angular/core';
import { Patient } from '../patients/patient';
import { PatientsService } from '../patients.service';
import { ExamsService } from '../exams.service';
import { LoginService } from '../login.service';
import { AdministrationService } from '../administration.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommerrorService } from '../commerror.service';
import { PregnancyService } from '../pregnancy.service';
import { GastroFormsService } from '../gastro-forms.service';
import { DiagnosisService } from '../diagnosis.service';
import { CalendarService } from '../calendar.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { BloodTestReferralService } from '../blood-test-referral.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../language.service';
import { PatexamsSidebarService } from '../patexams-sidebar/patexams-sidebar.service';
import { SignatureService } from '../signature.service';

export interface PrintHistoryTable {
  date: string;
  position: number;
  time: string;
  comments: string;
}

@Component({
  selector: 'app-patexams',
  templateUrl: './patexams.component.html',
  styleUrls: ['./patexams.component.scss'],
  standalone: false,
})
export class PatexamsComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['position', 'date', 'time', 'comments'];
  clickedRows = new Set<PrintHistoryTable>();

  @ViewChild('inputTitle')
  set inputTitle(element: ElementRef<HTMLInputElement>) {
    if (element) {
      element.nativeElement.focus();
    }
  }
  inform = false;
  showGynConsent = false;
  showGynConsentSelect = false;
  selectedGynConsentType = '';
  showComment = false;
  selectedForm;
  calendarForm = false;
  pat: Patient;
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  showPat = false;
  pregnancies: any = null;
  etype = 'OB STD';
  typeForm = false;
  examname: string;
  examSubType: string = null;
  concentForm;
  otherExams: any;
  formsExams: any[] = [];
  AttachedDocuments: any[] = [];
  AttachedAdminDocuments: any[] = [];
  calendarForms: any[] = [];
  notFormExams: any[] = [];
  gynConsents: any[] = [];
  unlinkedConsents: any[] = []; // consent forms that aren't linked to any pregnancy
  patientQuestionnaires: any[] = [];
  ecgExams: any[] = [];
  gastroForms: any[] = [];
  gastroVisits: any[] = [];
  gastroExams: any[] = [];
  letters: any;
  showLogin = false;
  AWLAlreadyExists = false;
  private destroy$ = new Subject();
  public examsLoaded$ = new Subject();
  toDelete;
  readydelete = false;
  referralToDelete: any = null;
  referralDeleteReady = false;
  goEx;
  newExam = true;
  closePreg: number = null;
  pregExams;
  defaults;
  startClinic: number;
  openAWL = false;
  subscription = new Subscription();
  continueExamSub = new Subscription();
  FORMS = ['Consultation Letter', 'Inform Consent'];
  ECG = ['Resting ECG', 'Ergometry', 'Holter ECG'];
  CARDIO = ['TTE Adults', 'Duplex Carotid', 'Stress', 'Stress-Echo'];
  GASTRO = ['Colonoscopy', 'Gastroscopy', 'Sigmoidoscopy'];
  INVASIVE = ['Amniocentesis', 'CVS'];
  showDiagnosisComments = false;
  GastroForms = ['Admission Form', 'Time Out Form'];
  gastroExamsChanged = new Subject();
  fanciness = 'simple';
  show_surrogate = false;
  showDiagnosisIcon = false;
  sanitizedSummary: SafeHtml;
  showPrintHistoryPopup = false;
  loadingPrint = false;
  examId: number;
  printHistoryData: any;
  plannerToDelete = false;
  signatureSubscription: Subscription;
  loginSub: Subscription;
  subDataReceived: Subscription;
  openDocumentsAdd = false;
  documentDelete = false;
  currentSignatureUrl: any = null;
  signatureLoading = false;
  signatureUploadStatus = '';

  // Consent Form:
  clinicPractitioners = [];
  shouldOpenExam = false;
  showConsentAgreementPopup = false;
  userHasAgreedToConsent = false;
  pendingGynConsentAction: (() => void) | null = null;
  practitionerSignatures: Record<string, { url: any; loading: boolean; status: string }> = {};

  constructor(
    public ce: CommerrorService,
    public gfs: GastroFormsService,
    public patService: PatientsService,
    public ps: PregnancyService,
    public examServe: ExamsService,
    public login: LoginService,
    public ds: DiagnosisService,
    public cf: CalendarService,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private referralService: BloodTestReferralService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private languageService: LanguageService,
    private patexamsSidebarService: PatexamsSidebarService,
    public signatureService: SignatureService,
    private administrationService: AdministrationService
  ) {
    this.login.loginMissing();
  }

  get isDefaultsPage(): boolean {
    return this.pat?.ID === 'default';
  }

  async ngOnInit() {
    if (!this.login.ishospital && this.login.premissions?.Consent) {
      this.examServe.getAllPractitioners().subscribe((data: any) => {
        this.clinicPractitioners = data;
        const selectedPractitioner = this.resolveConsentPractitioner();
        if (selectedPractitioner) {
          this.examServe.consentPractitioner =
            selectedPractitioner.Title + ' ' + selectedPractitioner.Name;
          this.setConsentDocUID();
        } else if (this.login.userType === 'doctor') {
          this.setConsentDocUID();
        } else {
          this.examServe.consentPractitioner = null;
          this.examServe.consentDocUID = null;
        }
      });
    }

    if (this.login.premissions?.Consent && !this.isDefaultsPage) {
      const examCodeMap: Record<string, string> = {
        '1st Trimester': '1st',
        'Early Anatomy': 'Early',
        '2nd/3rd Trimester': '2nd/3rd',
        'Late Anatomy': 'Late',
      };
      const consentExamTypes = [
        '1st',
        'NT',
        'Early',
        '2nd/3rd',
        'Weight Assessment',
        'Late',
        'Third Scan',
        'Specialized',
        'Fetal Echo',
        'Gynecology',
      ];
      const awlPat = this.patService.getPat() as any;
      this.examServe.consentExamType = null;
      // 1. If has appointmentId — use AppointmentExamType
      if (awlPat?.appointmentId) {
        const rawCode = awlPat.AppointmentExamType || awlPat.ExamCode;
        if (rawCode) {
          const mapped = examCodeMap[rawCode] || rawCode;
          this.examServe.consentExamType = consentExamTypes.includes(mapped) ? mapped : null;
        }
      } else if (awlPat?.ExamCode) {
        // 2. If ExamCode matches one of our consent types — use it
        const mapped = examCodeMap[awlPat.ExamCode] || awlPat.ExamCode;
        this.examServe.consentExamType = consentExamTypes.includes(mapped) ? mapped : null;
        // 3. If no match — stays null, user picks from dropdown
      }
    }

    try {
      this.pat = this.patService.getPat();
      //this.pat.asignVals(history.state.data);
    } catch {}
    if (this.login.isCardio) this.etype = 'Echo';
    if (this.login.isGastro) this.etype = 'Gastro';
    if (this.login.category.name == 'forms') this.etype = 'Forms';
    if (!this.isDefaultsPage) {
      this.resetPregs();
    } else {
      //defaults
      if (this.login.userType === 'doctor' && this.login.premissions?.Consent) {
        this.loadCurrentSignature();
      }
      this.examServe.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data['length']; i++) {
            const exam = data[i];
            const key =
              exam['ExamType'] === 'Specialized' && exam['ChangedExamTitle']
                ? 'Specialized_' + exam['ChangedExamTitle']
                : exam['ExamType'];
            this.defaults[key] = exam;
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }
    this.subscription = this.patService.lettersChange.subscribe((response) => {
      this.letters = response;
    });
    this.subscription = this.cf.caldeleted$.subscribe((data) => {
      this.resetPregs();
    });

    if (this.isDefaultsPage) {
      this.examServe.getCustomTitles();
    }

    if (
      this.isDefaultsPage &&
      this.login.userType === 'secretary' &&
      this.login.premissions?.Consent
    ) {
      this.examServe.getAllPractitioners().subscribe((data: any) => {
        this.clinicPractitioners = data;
        this.loadAllPractitionerSignatures();
      });
    }

    this.subDataReceived = this.examServe.dataReceived$.subscribe(() => {
      this.resetPregs();
    });

    if (this.login.premissions?.Consent) {
      this.login.countConcent();
      // Check if user has agreed to consent terms
      this.checkConsentAgreement();
    }

    this.continueExamSub = this.examServe.continueExam$.subscribe((shouldContinue = false) => {
      if (shouldContinue) {
        this.startExam(true);
      }
    });

    // Open patient-details popup when triggered from app-level sidebar
    this.patexamsSidebarService.showPat$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (this.showPat = true));
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subDataReceived) {
      this.subDataReceived.unsubscribe();
    }
    if (this.loginSub) {
      this.loginSub.unsubscribe();
    }
    if (this.signatureSubscription) {
      this.signatureSubscription.unsubscribe();
      this.patService.closeConsentSocket();
    }

    if (this.continueExamSub) {
      this.continueExamSub.unsubscribe();
    }
  }

  resetPregs() {
    this.examServe
      .getExams(this.pat?.PID.toString())
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.AttachedDocuments = data['Documents'];
          this.AttachedAdminDocuments = data['AdminDocuments'];
          this.pregnancies = data['pregnancies'];
          this.examServe.pregnancies = data['pregnancies'];
          for (const item of this.pregnancies) {
            this.examServe
              .getAllCalForms(item.AutoIndex)
              .pipe(takeUntil(this.destroy$))
              .subscribe((data) => {
                if (data[0].calendar.length > 0) {
                  item.calendarForms.push(data[0].calendar[0]);
                }
                if (data[0].concent.length > 0) {
                  item.forms = data[0].concent;
                }
                // for(let concentForm of data[0].concent)
                // item.forms.push(concentForm)
                if (this.login.premissions?.Consent) {
                  if (!this.signatureSubscription) {
                    //to prevent resubsribing after socket event
                    for (const form of item.forms) {
                      if (!this.checkApprovedConcent(form)) {
                        this.patService.openConsentSocket();
                        this.signatureSubscription = this.patService.signatureIncoming.subscribe(
                          (s) => {
                            this.resetPregs();
                          }
                        );
                        break;
                      }
                    }
                  }
                }
              });
            // this.examServe.getConcentForms(item.AutoIndex).subscribe((data) => {
            //   if(data[0])
            //     item.forms.push(data[0])
            // })
          }

          if (this.pregnancies && this.pregnancies.length > 0 && this.pregnancies[0].LMP) {
            this.pat.LMP = this.convertTimeZone(this.pregnancies[0].LMP);
          }
          // this.letters = this.patService.getConsultationLetter(this.pat);
          this.otherExams = data['other'];
          this.gynConsents = data['gynConsents'];
          this.unlinkedConsents = data['unlinkedConsents'];
          // AR-24 load answered/sent questionnaires for this patient
          if (this.login.premissions?.Questionnaires && this.pat?.PID != null) {
            this.examServe
              .getPatientQuestionnaires(this.pat.PID)
              .pipe(takeUntil(this.destroy$))
              .subscribe(
                (qData: any) => {
                  this.patientQuestionnaires = (qData && qData.items) || [];
                },
                (err) => {
                  console.log(err);
                }
              );
          }
          if (this.otherExams.length > 0) {
            this.otherExams.forEach((exam) => {
              if (this.FORMS.includes(exam.ExamType)) {
                this.formsExams.push(exam);
              } else {
                this.notFormExams.push(exam);
              }
            });
          }
          if (this.login.premissions?.Consent) {
            if (!this.signatureSubscription) {
              //to prevent resubsribing after socket event
              // Check gynConsents for unsigned forms
              if (this.gynConsents.length > 0) {
                for (const form of this.gynConsents) {
                  if (!this.checkApprovedConcent(form)) {
                    this.patService.openConsentSocket();
                    this.signatureSubscription = this.patService.signatureIncoming.subscribe(
                      (s) => {
                        this.resetPregs();
                      }
                    );
                    break;
                  }
                }
              }
              if (this.unlinkedConsents.length > 0) {
                for (const form of this.unlinkedConsents) {
                  if (!this.checkApprovedConcent(form)) {
                    this.patService.openConsentSocket();
                    this.signatureSubscription = this.patService.signatureIncoming.subscribe(
                      (s) => {
                        this.resetPregs();
                      }
                    );
                    break;
                  }
                }
              }
            }
          }
          if (this.pat.AWLID) {
            for (let i = 0; i < this.pregnancies.length; i++) {
              for (const e of this.pregnancies[i]['exams']) {
                if (e.AWLID == this.pat.AWLID) {
                  this.AWLAlreadyExists = true;
                  return;
                }
              }
            }
            for (const e of this.otherExams) {
              if (e.AWLID == this.pat.AWLID) {
                this.AWLAlreadyExists = true;
                return;
              }
            }
          }
        },
        (error) => {
          //add this later
          console.error(error);
        }
      );

    this.subscription = this.examsLoaded$.subscribe(() => {
      const v = this.gfs.getVisits(this.pat.PID);
      v.subscribe((data: any) => {
        this.gastroVisits = data;
        this.gastroVisits.forEach((visit, i) => {
          this.gastroVisits[i]['exams'] = this.gastroExams.filter((exam) => {
            return exam.CreationTime.split('T')[0] == visit.ExamDate.split('T')[0];
          });
          const f = this.gfs.getFormByVisit(visit.AutoIndex);
          f.subscribe((data) => {
            this.gastroVisits[i]['forms'] = data;
          });
        });
        this.gfs.loadForm(false, true, this.gastroVisits[0]['AWLID']);
      });
    });
    if (!this.loginSub) {
      this.loginSub = this.login.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
        /*if(this.login.ClinicID && this.login.ClinicID != this.startClinic){
        //trying to switch clinics on opening exams
        this.showLogin=false;
        this.cErr.Error = "Clinic Not Autorized on this patient";
        this.cErr.ErrorType = "Clinic Switched on Login";
        return;
      }*/
        if (this.goEx) {
          this.examServe.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
        } else {
          if (this.examname == 'Inform Consent' || this.concentForm) {
            this.showLogin = false;
            this.inform = true;
          } else {
            // Helper method to check if no matching form exists
            const hasNoMatchingForm = this.hasNoMatchingForm();
            const isExcludedExamType = this.isExcludedExamType();

            // Check if this is a Gynecology exam
            const isGynecologyExam = this.examname === 'Gynecology';

            if (hasNoMatchingForm && this.login.premissions.Consent && !isExcludedExamType) {
              if (this.examServe.consentPregnancyPastTerm(this.pregnancies)) {
                this.ce.showConsentNotice(
                  'GUI.errorMessages.consent.pastTermTitle',
                  'GUI.errorMessages.consent.pastTermNotice'
                );
              }
              this.inform = true;
              this.showLogin = false;
              this.examServe.openNewExam = true;
            } else if (isGynecologyExam && hasNoMatchingForm && this.login.premissions.Consent) {
              this.showGynConsentSelect = true;
              this.showLogin = false;
              this.examServe.openNewExam = true;
            } else {
              // may be an unlinked consent — setConcentExmID then ties it to this exam
              this.examServe.concentForm = this.matchingConsents(this.examname)[0];

              this.examServe.startExam(
                this.examname,
                this.pat.PID,
                this.pat.ID,
                this.pat.AWLID,
                this.pat.ExamLMP,
                null,
                this.examname === 'Specialized' ? this.examSubType : null
              );
            }
          }
        }
      });
    }
  }

  viewonly() {
    this.examServe.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }

  startForm(form = null) {
    if (!form) {
      const pastTermPregs = this.examServe.pastTermOpenPregnancies(this.pregnancies);
      if (pastTermPregs.length > 0) {
        const pregIDs = pastTermPregs.map((preg) => preg.AutoIndex);
        this.examServe.offerPastTermClose(pregIDs, () => {
          // patch the records we already hold so the retry cannot loop on a stale list
          pastTermPregs.forEach((preg) => (preg.ClosedDate = new Date()));
          this.startForm();
        });
        return;
      }
      if (this.hasValidConsent(this.examServe.consentExamType)) {
        this.ce.showConsentNotice(
          'GUI.errorMessages.consent.duplicateTitle',
          'GUI.errorMessages.consent.duplicateMsg'
        );
        return;
      }
    }
    if (this.examname == 'Inform Consent' || form) {
      this.examServe.examID = null;
      if (form && form.CreationTime) {
        form.CreationTime = this.convertTimeZone(form.CreationTime);
      }
      this.concentForm = form;
      this.examServe.openNewExam = false;
      this.examServe.loadPrevDocSign = true;
      this.inform = true;
    } else {
      this.concentForm = null;
      this.inform = false;
      const today = new Date().toISOString().split('T')[0];
      let checkAwl = true;
      if (this.gastroVisits.length > 0) {
        checkAwl =
          new Date(this.gastroVisits[0].ExamDate.split('T')[0]).toISOString().split('T')[0] !==
          today;
      }
      this.showLogin = true;
      return;
    }
  }

  startGynForm(form = null) {
    // Check if user needs to see consent agreement popup
    if (!form && this.login.premissions?.Consent && !this.userHasAgreedToConsent) {
      // Store the action to execute after user agrees
      this.pendingGynConsentAction = () => {
        this.executeStartGynForm(form);
      };
      this.showConsentAgreementPopup = true;
      return;
    }

    this.executeStartGynForm(form);
  }

  executeStartGynForm(form = null) {
    // Allow creation if we have a consent type selected OR we're opening an existing form OR examname is Gynecology
    if (this.selectedGynConsentType || form || this.examname == 'Gynecology') {
      this.examServe.examID = null;
      if (form && form.CreationTime) {
        form.CreationTime = this.convertTimeZone(form.CreationTime);
      }
      this.concentForm = form;
      if (form && form.GynConsentType) {
        this.selectedGynConsentType = form.GynConsentType;
      }
      this.examServe.openNewExam = false;
      this.examServe.loadPrevDocSign = true;
      this.showGynConsent = true;
    } else {
      this.concentForm = null;
      this.showGynConsent = false;
      const today = new Date().toISOString().split('T')[0];
      let checkAwl = true;
      if (this.gastroVisits.length > 0) {
        checkAwl =
          new Date(this.gastroVisits[0].ExamDate.split('T')[0]).toISOString().split('T')[0] !==
          today;
      }
      this.showLogin = true;
      return;
    }
  }

  goForm(form) {
    this.typeForm = true;
    const isTimeOut = form['FormName'] == 'Time Out Form';
    this.gfs.loadForm(isTimeOut, form);
  }

  onExamTypeChange() {
    // Reset examSubType when exam type changes away from Specialized
    if (this.examname !== 'Specialized') {
      this.examSubType = null;
    }
    if (this.examname == 'Inform Consent') {
      this.selectedGynConsentType = '';
    }
  }

  async startExam(shouldContinue = false) {
    // AR-24: "New Questionnaire" is not a document — open the send popup instead.
    if (this.examname === 'Send Questionnaire') {
      this.openSendQuestionnaireForPatient();
      return;
    }
    if (this.examServe.awaitPrintHistory && !this.isDefaultsPage) {
      return;
    }
    if (!shouldContinue && this.examname !== 'Consultation Letter' && !this.isDefaultsPage) {
      this.examServe
        .getAllTodaysExams(this.examname, this.examname === 'Specialized' ? this.examSubType : null)
        .subscribe((data: any) => {
          const alreadyHasExam: boolean = data;

          if (alreadyHasExam && !shouldContinue) {
            this.showLogin = false;
            let examName;
            if (this.languageService.isOB(this.examname)) {
              examName = this.translate.instant(
                'GUI.Patient History.ExamTypes.OB.' + this.examname
              );
              // Add sub-type for Specialized exam
              if (this.examname === 'Specialized' && this.examSubType) {
                const subTypeName = this.translate.instant('exam.type.OBS.' + this.examSubType);
                examName = `${examName} - ${subTypeName}`;
              }
            } else {
              examName = this.translate.instant(
                'GUI.Patient History.ExamTypes.GYN.' + this.examname
              );
            }
            return this.ce.hasExam(
              `${examName} - ${this.translate.instant('GUI.errorMessages.examExists.title')}`,
              false
            );
          }
          this.continueExam(shouldContinue);
        });
    } else {
      this.continueExam(shouldContinue);
    }
  }

  continueExam(forceNewExam = false) {
    const today = new Date().toISOString().split('T')[0];
    this.examServe.examID = null;
    let checkAwl = true;
    if (this.gastroVisits.length > 0) {
      checkAwl =
        new Date(this.gastroVisits[0].ExamDate.split('T')[0]).toISOString().split('T')[0] !== today;
    }

    if (!this.etype || !this.examname) {
      return;
    }

    if (!this.isDefaultsPage) {
      this.concentForm = null;
      this.newExam = true;

      // If forceNewExam is true, the user confirmed they want to create a duplicate exam
      // In this case, we should bypass consent form checks and go straight to exam creation
      if (forceNewExam) {
        // For Gynecology exam with consent, show the consent type selector
        if (this.examname === 'Gynecology' && this.login.premissions?.Consent) {
          this.showGynConsentSelect = true;
          this.examServe.openNewExam = true;
          this.shouldOpenExam = true;
          return;
        }
        // For other exams, just show login to start the exam
        this.showLogin = true;
        return;
      }

      // Check if this is a Gynecology exam and needs consent (when NOT forcing new exam)
      if (this.examname === 'Gynecology' && this.login.premissions?.Consent) {
        // Show consent type selector
        this.showGynConsentSelect = true;
        this.examServe.openNewExam = true;
        this.shouldOpenExam = true;
        return;
      }

      this.showLogin = true;
      return;
    } else {
      const defaultKey =
        this.examname === 'Specialized' && this.examSubType
          ? 'Specialized_' + this.examSubType
          : this.examname;
      const resolvedDefault =
        this.defaults[defaultKey] ||
        (!this.isDefaultsPage && this.examname === 'Specialized'
          ? this.defaults['Specialized']
          : null);
      if (resolvedDefault) {
        this.examServe.goExam(null, resolvedDefault, this.examname);
      } else {
        this.examServe.startExam(
          this.examname,
          0,
          'default',
          null,
          null,
          null,
          this.examname === 'Specialized' ? this.examSubType : null
        );
      }
    }
  }

  canOpen(): boolean {
    return (
      this.login.canStartExam(this.pat.AWLID != null) &&
      (!this.AWLAlreadyExists || this.login.AWLUnlimited) &&
      (!this.login.separatedClinic ||
        this.login.isAdmin ||
        !this.patService.getPat().UID ||
        this.patService.getPat().UID == this.login.UID ||
        this.patService.getPat()['AWLUID'] == this.login.UID)
    );
  }

  goExam(pregid: number, exam, examtype: string, examtime: string) {
    if (
      (exam.Locked && exam.LockedBy.toLowerCase() != this.login.loginname.toLowerCase()) ||
      !this.canView(exam)
    )
      return;
    const etime = new Date(examtime);
    let closed;
    if (exam.ClosedDate) closed = new Date(exam.ClosedDate);
    const now = new Date();
    if (
      examtype != 'Emergency Room' &&
      ((!this.examServe.examClosed(etime) && !this.login.isCardio) ||
        (this.login.isCardio && (!exam.ClosedDate || this.examServe.examClosed(closed)))) &&
      (this.login.userType == 'doctor' ||
        this.login.userType == 'visitingdoc' ||
        this.login.userType == 'tech')
    ) {
      this.newExam = false;
      this.showLogin = true;
      this.goEx = { preg: pregid, exam: exam, etype: examtype };
      if (this.login.ClinicID) this.startClinic = this.login.ClinicID;
    } else this.examServe.goExam(pregid, exam, examtype);
  }

  canView(exam) {
    return (
      !this.login.separatedClinic ||
      this.login.isAdmin ||
      this.login.userType == 'secretary' ||
      exam.UID == this.login.doctor
    );
  }

  askDelete(
    exam,
    concent = false,
    gynConsent = false,
    unlinkedConsents = false,
    calendarPlanner = false,
    document = false
  ) {
    this.plannerToDelete = false;
    const etime = new Date(exam.CreationTime);
    if (document) {
      this.documentDelete = true;
      this.toDelete = exam; /**document */
    } else if (calendarPlanner) {
      this.plannerToDelete = true;
      this.toDelete = exam;
    } else if (this.defaults || !this.examServe.examClosed(etime)) {
      this.plannerToDelete = false;
      //if the exam is from today allow delete
      this.toDelete = {
        ...exam,
        concent,
        gynConsent,
        unlinkedConsents,
        calendarPlanner,
      };
    }
    return false;
  }

  deleteExam() {
    this.pat.AWLID = this.toDelete.AWLID;

    this.examServe.deleteExam(
      this.toDelete.AutoIndex,
      this.toDelete.AWLID,
      this.toDelete.concent || this.toDelete.gynConsent || this.toDelete.unlinkedConsents
        ? 'concent'
        : null
    );

    if (!this.defaults) {
      for (let i = 0; i < this.pregnancies.length; i++) {
        for (let j = 0; j < this.pregnancies[i]['exams']?.length; j++) {
          if (this.pregnancies[i]['exams'][j].AutoIndex == this.toDelete.AutoIndex) {
            this.pregnancies[i]['exams'].splice(j, 1);
            break;
          }
        }
      }
      for (let i = 0; i < this.otherExams.length; i++) {
        if (this.otherExams[i].AutoIndex == this.toDelete.AutoIndex) {
          this.otherExams.splice(i, 1);
          this.notFormExams = this.otherExams;
          break;
        }
      }

      if (this.toDelete.concent) {
        for (let i = 0; i < this.pregnancies.length; i++) {
          for (let j = 0; j < this.pregnancies[i]['forms'].length; j++) {
            if (this.pregnancies[i]['forms'][j].AutoIndex == this.toDelete.AutoIndex) {
              this.pregnancies[i]['forms'].splice(j, 1);
              break;
            }
          }
        }
      }

      if (this.toDelete.gynConsent) {
        for (let i = 0; i < this.gynConsents.length; i++) {
          if (this.gynConsents[i].AutoIndex == this.toDelete.AutoIndex) {
            this.gynConsents.splice(i, 1);
            break;
          }
        }
      }
      if (this.toDelete.unlinkedConsents) {
        for (let i = 0; i < this.unlinkedConsents.length; i++) {
          if (this.unlinkedConsents[i].AutoIndex == this.toDelete.AutoIndex) {
            this.unlinkedConsents.splice(i, 1);
            break;
          }
        }
      }
    } else {
      this.examServe.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data['length']; i++) {
            const exam = data[i];
            const key =
              exam['ExamType'] === 'Specialized' && exam['ChangedExamTitle']
                ? 'Specialized_' + exam['ChangedExamTitle']
                : exam['ExamType'];
            this.defaults[key] = exam;
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }
    this.toDelete = null;
    this.readydelete = false;
  }

  showClose(pregid: number) {}

  closCalForm(event) {
    if (event == '1') this.examServe.concentForm = null;
    if (
      event == '2' ||
      (this.examServe.openNewExam &&
        this.login.userType !== 'secretary' &&
        this.etype !== 'Forms' &&
        this.shouldOpenExam)
    ) {
      this.examServe.startExam(
        this.examname,
        this.pat.PID,
        this.pat.ID,
        this.pat.AWLID,
        this.pat.ExamLMP,
        this.examServe.concentForm,
        this.examname === 'Specialized' ? this.examSubType : null
      );
    }
    this.examServe.openNewExam = false;
    this.calendarForm = false;
    this.inform = false;
    if (!this.isDefaultsPage) {
      this.resetPregs();
    } else {
      //defaults
      this.examServe.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data['length']; i++) {
            const exam = data[i];
            const key =
              exam['ExamType'] === 'Specialized' && exam['ChangedExamTitle']
                ? 'Specialized_' + exam['ChangedExamTitle']
                : exam['ExamType'];
            this.defaults[key] = exam;
          }
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  closeGYNConsentSelect(event: string) {
    if (event === 'cancel') {
      this.examServe.concentForm = null;
      this.selectedGynConsentType = ''; // Reset selection
      this.showGynConsentSelect = false;
      return;
    }

    if (event === 'openForm') {
      // Validate that a consent type is selected
      if (!this.selectedGynConsentType) {
        return; // Don't proceed if nothing selected
      }

      // Check if user needs to see consent agreement popup before opening form
      if (this.login.premissions?.Consent && !this.userHasAgreedToConsent) {
        // Store the action to execute after user agrees/disagrees
        this.pendingGynConsentAction = () => {
          // Open the consent form after agreement
          this.showGynConsent = true;
        };
        this.showGynConsentSelect = false;
        this.showConsentAgreementPopup = true;
        return;
      }

      // Open the consent form
      this.showGynConsent = true;
      this.showGynConsentSelect = false;
      return;
    }

    // Handle consent form close - event "1" means saved successfully, "2" means continue to exam
    if (event === '1') {
      this.examServe.concentForm = null;
    }

    if (
      event === '2' ||
      event === 'continueWithoutConsent' ||
      (this.examServe.openNewExam &&
        this.login.userType !== 'secretary' &&
        this.etype !== 'Forms' &&
        this.shouldOpenExam)
    ) {
      this.examServe.startExam(
        this.examname,
        this.pat.PID,
        this.pat.ID,
        this.pat.AWLID,
        this.pat.ExamLMP,
        this.examServe.concentForm,
        this.examname === 'Specialized' ? this.examSubType : null
      );
    }
    this.examServe.openNewExam = false;
    this.showGynConsent = false;
    this.showGynConsentSelect = false;

    if (!this.isDefaultsPage) {
      this.resetPregs();
    } else {
      //defaults
      this.examServe.getDefaults().subscribe(
        (data) => {
          this.defaults = [];
          for (let i = 0; i < data['length']; i++) this.defaults[data[i]['ExamType']] = data[i];
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }

  deleteDefault(ex: string, subType: string = null) {
    const key = ex === 'Specialized' && subType ? 'Specialized_' + subType : ex;
    if (this.defaults[key]) {
      this.askDelete(this.defaults[key]);
    }
  }

  getDiagnosis(exam, show = false) {
    let strDiagnosis = '';
    if (exam && exam.DiagnosisCodes) {
      const temp = this.ds.BuildList(exam.DiagnosisCodes);
      if (temp.length > 0) {
        strDiagnosis = '';
        for (let i = 0; i < temp.length; i++) {
          strDiagnosis += temp[i][1].split('>')[temp[i][1].split('>').length - 1];
          if (temp.length > 1 && i < temp.length - 1) strDiagnosis += ',';
        }
      }
    } else if (exam && exam.Anomalies && exam.Anomalies != '') strDiagnosis = exam.Anomalies;
    if (show && exam['Anomalies'] && exam.Anomalies.length > 15)
      // return 'Read More'
      return exam.Anomalies.split(' ')[0] + '...';
    else return strDiagnosis;
  }

  // return the diagnosis
  getDiagnosisTree(exam) {
    this.getExamSummary(exam);
    let strDiagnosis = '';
    if (exam && exam.DiagnosisCodes) {
      const temp = this.ds.BuildListPatientHistory(exam.DiagnosisCodes, true, exam.ExamType);
      if (temp.length > 0) {
        strDiagnosis = '';
        for (let i = 0; i < temp.length; i++) {
          if (this.login.isSheba) {
            strDiagnosis += temp[i][1] + ',';
          } else {
            strDiagnosis += temp[i][1].split('>')[temp[i][1].split('>').length - 1];
            if (temp.length > 1 && i < temp.length - 1) strDiagnosis += ',\n';
          }
        }
      }
    }
    return strDiagnosis;
  }

  // return summary of exam
  getExamSummary(exam) {
    return exam.Diagnosis;
  }

  //  return the summary recommendations
  getExamRecommendation(exam) {
    return exam.Recomm;
  }

  // change diagnosis hover content order
  switchMainDiagnosisContent(exam) {
    this.showDiagnosisComments = false;
    const diagnosesTree = this.getDiagnosisTree(exam);
    const diagnosisComments = this.displayDiagnosisComments(exam);
    if (diagnosisComments || diagnosesTree) {
      this.showDiagnosisComments = true;
      return diagnosesTree;
    }

    const summaryOfExam = this.getExamSummary(exam);
    if (summaryOfExam) {
      this.showDiagnosisComments = false;
      this.sanitizedSummary = this.sanitizer.sanitize(1, summaryOfExam);

      return this.sanitizedSummary;
    }
    const recommendations = this.getExamRecommendation(exam);
    if (recommendations) {
      this.showDiagnosisComments = false;
      return recommendations;
    }
    return null;
  }

  displayDiagnosisIcon(exam) {
    if (exam.DiagnosisCodes || exam.Anomalies) {
      return (this.showDiagnosisIcon = true);
    }
    this.showDiagnosisIcon = false;
  }

  displayDiagnosisComments(exam) {
    let strDiagnosis = '';
    if (exam && exam.Anomalies) {
      strDiagnosis = exam.Anomalies;
    }
    return strDiagnosis;
  }

  loadCalendarForm(form) {
    this.calendarForm = true;
    this.selectedForm = form;
  }

  getConcent(exam) {
    let temp = this.examServe.pregnancies.filter((i) => i.AutoIndex == exam.PregIndex);
    if (temp.length > 0) {
      temp = temp[0].forms.filter((i) => i.ExamID == exam.AutoIndex);
    }
    if (temp.length > 0) return temp[0];
    else return false;
  }

  pregClosed() {
    for (const p of this.pregnancies) {
      if (p.AutoIndex == this.closePreg) p.ClosedDate = new Date();
    }
    this.closePreg = null;
  }

  // This function toggles the print history popup.
  togglePrintHistoryPopup() {
    if (this.examServe.awaitPrintHistory) {
      return;
    }
    this.showPrintHistoryPopup = !this.showPrintHistoryPopup;
  }

  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  // AR-24: triggered from Create-New > Letters and Certificates > Send
  // Questionnaire. No ExamType is passed, so the popup preselects nothing
  // and the user picks which questionnaire to send.
  openSendQuestionnaireForPatient() {
    const p: any = this.pat || {};
    this.openSendQuestionnaire({ Mobile: p.Mobile || p.Phone || '', ID: p.ID, PID: p.PID });
  }

  // AR-24: on popup close, re-render exams and reload the questionnaire list
  // so a freshly-sent questionnaire shows up without a manual reload.
  onSendQuestionnaireClosed() {
    this.showSendQuestionnaire = false;
    if (this.pat && this.pat.PID != null) this.resetPregs();
  }

  // This function retrieves a list of print histories for a given exam.
  getPrintHistoryList(exam) {
    if (this.examServe.awaitPrintHistory) {
      return;
    }
    this.loadingPrint = true;
    if (!exam) {
      return;
    }
    this.examId = exam.AutoIndex;

    this.http.get(`api/print-history/list/${this.examId.toString()}`).subscribe((data) => {
      const sortedData = Object.values(data);
      sortedData.sort(
        (a, b) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime()
      );

      // Convert creationDate to UTC for each element
      sortedData.forEach((element) => {
        element.creationTime = this.formatDateToUTC(element.creationDate);
        element.creationDate = element.creationDate;
      });

      this.printHistoryData = sortedData;
      this.loadingPrint = false;
    });
  }

  formatDateToUTC(dateString: string): string {
    const date = new Date(dateString);
    // Convert local date to UTC
    const utcDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
    // Format date to string using the desired format and timezone ('Asia/Jerusalem' in this case)
    return this.datePipe.transform(utcDate, 'HH:mm', 'Asia/Jerusalem');
  }

  // This function is used to print a PDF file from a selected row.
  printSelectPDF(selectRow) {
    this.loadingPrint = true;
    this.http
      .get(`/api/print-history/print/${this.examId.toString()}/${selectRow.fileName}`, {
        responseType: 'blob',
      })
      .subscribe((data) => {
        const file = new Blob([data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.loadingPrint = false;
      });
  }

  private resolveConsentPractitioner(): any {
    const pat = this.patService.getPat() as any;
    if (this.clinicPractitioners.length < 2 || this.login.separatedClinic) {
      if (this.login.separatedClinic) {
        return this.clinicPractitioners.find((p) => p.UID == pat?.UID) || null;
      }
      return this.clinicPractitioners[0] || null;
    }
    // Multi-doctor non-separated clinic — use appointment doc if available
    if (pat?.AppointmentDocUID) {
      return this.clinicPractitioners.find((p) => p.UID == pat.AppointmentDocUID) || null;
    }
    return null;
  }

  setConsentDocUID() {
    let selectedDoc: any;
    if (this.login.userType === 'doctor') {
      selectedDoc = this.login;
    } else {
      selectedDoc = this.clinicPractitioners.find((user) => {
        return user?.Title + ' ' + user?.Name === this.examServe.consentPractitioner;
      });
    }
    this.examServe.consentDocUID = selectedDoc?.UID;
  }

  isConcentExpired(concent: any): boolean {
    if (concent.ExamID) {
      return false;
    }
    const created = new Date(concent.CreationTime);
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - 3);
    return created < cutoff;
  }

  checkApprovedConcent(consent: any) {
    let valid = false;
    if (
      consent.approved &&
      consent.approved !== 'appotropus' &&
      consent.patSign &&
      consent.patSignApproved &&
      consent.docSign
    ) {
      valid = true;
    } else if (
      consent.approved &&
      consent.approved === 'appotropus' &&
      consent.patSign &&
      consent.docSign
    ) {
      valid = true;
    }
    return valid;
  }

  // AR-24 open answered questionnaire PDF (same-origin proxy)
  openQuestionnairePdf(q: any) {
    if (q && q.answeredDate && q.code) {
      window.open('api/questionnaires/pdf/' + q.code);
    }
  }

  convertTimeZone(dateToFormat) {
    if (!dateToFormat) return;
    const utcTimestamp = dateToFormat;
    const dateInUTC = new Date(utcTimestamp);

    // Set the time zone to Israel (Asia/Jerusalem)
    const israelTimeZone = 'Asia/Jerusalem';
    const options = { timeZone: israelTimeZone, hour12: false };

    // Format the date according to the Israel time zone
    return this.examServe.parseConsentDate(new Date(dateInUTC.toLocaleString('en-US', options)));
  }

  redirectAdministration(type) {
    this.administrationService.getUrl(type).subscribe((url) => {
      window.location.href = url + '/' + this.patService.currentPatient.PID;
    });
  }

  openDocument(docId) {
    window.open(`api/patient/getDocument/${docId}`);
  }

  openReferralPrintout(referralId) {
    if (referralId) {
      window.open(`/api/referrals/printpdf/${referralId}/he`, '_blank');
    }
  }

  askDeleteReferral(exam: any, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.referralToDelete = exam;
    this.referralDeleteReady = false;
  }

  confirmDeleteReferral() {
    if (!this.referralToDelete || !this.referralToDelete.ReferralId) return;
    const exam = this.referralToDelete;
    this.referralService.deleteReferral(exam.ReferralId).subscribe(
      () => {
        exam.ReferralId = null;
        this.referralToDelete = null;
        this.referralDeleteReady = false;
      },
      () => {
        this.referralToDelete = null;
        this.referralDeleteReady = false;
      }
    );
  }

  deleteDocument() {
    console.log(this.toDelete, 'to delete');
    if (!this.toDelete || !this.toDelete.AutoIndex) return;
    this.http.delete(`api/patient/document/${this.toDelete.AutoIndex}`).subscribe(() => {
      this.resetPregs();
      this.toDelete = null;
      this.documentDelete = false;
    });
  }

  private isExcludedExamType(): boolean {
    return (
      this.examname === 'Consultation Letter' ||
      this.examname === 'Gynecology' ||
      this.examname === 'Pediatric Echo'
    );
  }

  // Pregnancy forms plus unlinked ones — a post-close consent has no PregID and only lives there.
  private matchingConsents(examType: string): any[] {
    const pregForms = this.pregnancies?.length ? this.pregnancies[0].forms || [] : [];
    return this.examServe.usableConsents([...pregForms, ...this.unlinkedConsents], examType);
  }

  private hasValidConsent(examType: string): boolean {
    return this.matchingConsents(examType).length > 0;
  }

  private hasNoMatchingForm(): boolean {
    return this.matchingConsents(this.examname).length === 0;
  }

  checkConsentAgreement() {
    this.http.get('/api/consent/check-agreement').subscribe(
      (response: any) => {
        this.userHasAgreedToConsent = response.agreed;
      },
      (error) => {
        console.error('Error checking consent agreement:', error);
        this.userHasAgreedToConsent = false;
      }
    );
  }

  handleConsentAgreement(agreed: boolean, dontShowAgain = false) {
    if (agreed) {
      if (dontShowAgain) {
        // Save the user's agreement to not show again
        this.http.post('/api/consent/save-agreement', { agreed: true }).subscribe(
          () => {
            this.userHasAgreedToConsent = true;
            this.showConsentAgreementPopup = false;
            // Execute pending action if any
            if (this.pendingGynConsentAction) {
              this.pendingGynConsentAction();
              this.pendingGynConsentAction = null;
            }
          },
          (error) => {
            console.error('Error saving consent agreement:', error);
          }
        );
      } else {
        // User agreed but didn't select "don't show again"
        this.showConsentAgreementPopup = false;
        // Execute pending action if any
        if (this.pendingGynConsentAction) {
          this.pendingGynConsentAction();
          this.pendingGynConsentAction = null;
        }
      }
    } else {
      // User declined
      this.showConsentAgreementPopup = false;
      this.pendingGynConsentAction = null;
    }
  }

  loadCurrentSignature() {
    this.signatureLoading = true;
    this.signatureService.checkSignatureExists().subscribe(
      (blob: Blob) => {
        this.signatureLoading = false;
        if (blob && blob.size > 0) {
          this.currentSignatureUrl = this.sanitizer.bypassSecurityTrustUrl(
            URL.createObjectURL(blob)
          );
        } else {
          this.currentSignatureUrl = null;
        }
      },
      () => {
        this.signatureLoading = false;
        this.currentSignatureUrl = null;
      }
    );
  }

  deleteSignature() {
    this.signatureLoading = true;
    this.signatureService.deleteSignature().subscribe(
      () => {
        this.currentSignatureUrl = null;
        this.signatureLoading = false;
        this.signatureUploadStatus = '';
      },
      (error) => {
        this.signatureLoading = false;
        console.error(error);
      }
    );
  }

  onSignatureFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;
    this.signatureUploadStatus = '';
    this.signatureLoading = true;
    this.signatureService.uploadSignature(file).subscribe(
      () => {
        this.signatureUploadStatus = 'Signature uploaded successfully';
        this.loadCurrentSignature();
      },
      (error) => {
        this.signatureLoading = false;
        this.signatureUploadStatus = 'Upload failed';
        console.error(error);
      }
    );
    input.value = '';
  }

  loadPractitionerSignature(uid: string) {
    if (!this.practitionerSignatures[uid]) {
      this.practitionerSignatures[uid] = { url: null, loading: true, status: '' };
    } else {
      this.practitionerSignatures[uid].loading = true;
    }
    this.signatureService.checkSignatureExists(uid).subscribe(
      (blob: Blob) => {
        this.practitionerSignatures[uid].loading = false;
        if (blob && blob.size > 0) {
          this.practitionerSignatures[uid].url = this.sanitizer.bypassSecurityTrustUrl(
            URL.createObjectURL(blob)
          );
        } else {
          this.practitionerSignatures[uid].url = null;
        }
      },
      () => {
        this.practitionerSignatures[uid].loading = false;
        this.practitionerSignatures[uid].url = null;
      }
    );
  }

  loadAllPractitionerSignatures() {
    for (const p of this.clinicPractitioners) {
      this.loadPractitionerSignature(p.UID);
    }
  }

  onPractitionerSignatureSelected(uid: string, event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return;
    if (!this.practitionerSignatures[uid]) {
      this.practitionerSignatures[uid] = { url: null, loading: true, status: '' };
    }
    this.practitionerSignatures[uid].status = '';
    this.practitionerSignatures[uid].loading = true;
    this.signatureService.uploadSignatureForUid(uid, file).subscribe(
      () => {
        this.practitionerSignatures[uid].status = 'Uploaded successfully';
        this.loadPractitionerSignature(uid);
      },
      (error) => {
        this.practitionerSignatures[uid].loading = false;
        this.practitionerSignatures[uid].status = 'Upload failed';
        console.error(error);
      }
    );
    input.value = '';
  }

  deletePractitionerSignature(uid: string) {
    if (!this.practitionerSignatures[uid]) {
      this.practitionerSignatures[uid] = { url: null, loading: true, status: '' };
    }
    this.practitionerSignatures[uid].loading = true;
    this.signatureService.deleteSignatureForUid(uid).subscribe(
      () => {
        this.practitionerSignatures[uid].url = null;
        this.practitionerSignatures[uid].loading = false;
        this.practitionerSignatures[uid].status = '';
      },
      (error) => {
        this.practitionerSignatures[uid].loading = false;
        console.error(error);
      }
    );
  }
}
